import { useState, ChangeEvent } from 'react';

//import { Helmet } from 'react-helmet-async';
import { Box, Tabs, Tab, Grid, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import RecentActivity from './RecentActivity';
import ParametersGasStationTabEdit from './ParametersGasStationTabEdit';
import ParametersCryoptoPaymentTabEdit from './ParametersCryoptoPaymentTabEdit';
import InfoProjectTabEdit from './InfoProjectTabEdit';
import { useRecordContext, EditBase, Edit, SimpleForm, Toolbar, SaveButton, ShowButton } from "react-admin";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import ComponentEdit from '../../../components/PageComponents/ComponentEdit';
const TabsWrapper = styled(Tabs)(
  () => `
`
);
const Content = () => {
  const record = useRecordContext();
  if (!record) return null;
  return (<ComponentEdit title="Edit entity" subtitle={record.name || ""}>
    <ContentEdit />
  </ComponentEdit>)
}
const ProjectEdit = () => {
  return (
    <>
    <EditBase >
      <Content/>
    </EditBase>
    </>

  )
}

const ParametersTab = () => {
  const record = useRecordContext();
  if (!record) return null;
  const tabByProjectType = {
    "gasStation": <ParametersGasStationTabEdit />,
    "cryptoPayment": <ParametersCryoptoPaymentTabEdit />,
  };
  
  // Return the component directly without casting
  return tabByProjectType[record.typeProject] || null;
}

const ContentEdit = () => {

  const [currentTab, setCurrentTab] = useState<string>('infoProject');
  const { t }: { t: any } = useTranslation();

  const tabs = [
    { value: 'infoProject', label: t('Information') },
    { value: 'parameters', label: t('Parameters') },
  ];

  const handleTabsChange = (_event: ChangeEvent<{}>, value: string): void => {
    setCurrentTab(value);
  };

  return (
    <>
      <Box
        sx={{
          mt: 3,
          marginBottom:4
        }}
      >
        <Grid
          sx={{
            px: 4,
          }}
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={4}
        >

          <Grid item xs={10} md={10}>
            <TabsWrapper
              onChange={handleTabsChange}
              value={currentTab}
              variant="scrollable"
              scrollButtons="auto"
              textColor="primary"
              indicatorColor="primary"
            >
              {tabs.map((tab) => (
                <Tab key={tab.value} label={tab.label} value={tab.value} />
              ))}
            </TabsWrapper>
          </Grid>
          <Grid item xs={2} md={2} sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
            <ShowButton icon={<VisibilityOutlinedIcon />} />
          </Grid>
          <Grid item xs={12} md={8}>
          <Edit redirect="show" actions={false}>
          <SimpleForm toolbar={<Toolbar sx={{ m: 2 }}><SaveButton label={t("Save")} /></Toolbar>}>
            {currentTab === 'infoProject' && <InfoProjectTabEdit />}
            {currentTab === 'parameters' && <ParametersTab />}
          </SimpleForm>
          </Edit>
          </Grid>
          <Grid item xs={12} md={4}>
            <RecentActivity />
          </Grid>
        </Grid>
      </Box>
      </>
  );
}

export default ProjectEdit